import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { PaginatedResult } from '../model/PaginatedResult';
import { Libreria } from '../model/Libreria';

@Injectable({
  providedIn: 'root'
})
export class LibreriasService {

  private http = inject(HttpClient);

  constructor() { }

  getLiberias(page: number): Observable<PaginatedResult<Libreria>> {
    return this.http.get<PaginatedResult<Libreria>>(`${environment.apiUrl}/bookstores/?page=${page + 1}`, { withCredentials: true });
  }
}
